import React from "react";
import { string, number, object, bool } from "prop-types";

import HeadlineIcon from "../headline-icon";

import "./headline.m.css";

const Headline = ({
  useAlternateHeadline = false,
  text,
  headerType = 1,
  headerLevel = 1,
  story,
  width = 15,
  height = 15,
  ...props
}) => {
  const HeaderTag = "h" + headerLevel;

  if (useAlternateHeadline) {
    return (
      <div
        styleName={`headline headline-type-${headerType}`}
        className={`headline headline-type-${headerType}`}
        {...props}
      >
        {text}
      </div>
    );
  }

  return (
    <HeaderTag
      styleName={`headline headline-type-${headerType}`}
      className={`headline headline-type-${headerType}`}
      {...props}
    >
      {story && <HeadlineIcon story={story} width={width} height={width} />}
      {text}
    </HeaderTag>
  );
};

Headline.propTypes = {
  text: string,
  story: object,
  headerType: number,
  headerLevel: number,
  width: number,
  height: number,
  useAlternateHeadline: bool,
};

export default Headline;
